import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {Router} from '@angular/router';

@Component({
  selector: 'app-confirm-fail',
  templateUrl: './confirm-fail.component.html'
})
export class ConfirmFailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmFailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
    if (this.data.hashKey && this.data.tenantId) {
      this.router.navigate([`kyc-confirm-account-anonymous/${this.data.hashKey}/${this.data.tenantId}`], {});
    } else {
      this.router.navigate(['/kyc-confirm-account']);
    }
  }

}
